import React from "react";
import { useApp, LANGUAGES } from "@/context/AppContext";
import { Flag } from "@/components/Flag";

// Sélecteur de langue unique (FR / EN / ES / PT) des pages publiques, légales et de connexion :
// le choix est mémorisé (yalola.lang) et suivi par toutes les pages ouvertes ensuite.
export const LangFlags = ({ testId = "lang", size = 18, className = "" }) => {
  const { lang, setLang } = useApp();
  return (
    <div className={`flex items-center gap-1 ${className}`} role="radiogroup" aria-label="Langue" data-testid={`${testId}-lang-row`}>
      {LANGUAGES.map((l) => (
        <button
          key={l.code}
          type="button"
          role="radio"
          aria-checked={lang === l.code}
          onClick={() => setLang(l.code)}
          className="h-8 w-8 rounded-lg grid place-items-center border-2 transition-all"
          style={{ borderColor: lang === l.code ? "var(--yalola-primary)" : "transparent" }}
          title={l.label}
          data-testid={`${testId}-lang-${l.code}`}
        >
          <Flag code={l.code} size={size} />
        </button>
      ))}
    </div>
  );
};

/** Lien qui quitte l'app (navigateur externe, nouvel onglet) : la langue courante voyage dans l'URL (`?lang=`). */
export const withLang = (href, lang) => (lang ? `${href}${href.includes("?") ? "&" : "?"}lang=${lang}` : href);

export default LangFlags;
